export class MonthlyPresenceSorting {
    static WORKER_DNI = 'workerDNI';
    static WORKER_NAME = 'workerName';
    static WORKER_COMPANY = 'workerCompany';

    _selected = MonthlyPresenceSorting.WORKER_DNI;
    _asc = {
        [MonthlyPresenceSorting.WORKER_DNI]: true,
        [MonthlyPresenceSorting.WORKER_NAME]: true,
        [MonthlyPresenceSorting.WORKER_COMPANY]: true,
    };

    constructor(
        selected,
        asc,
    ) {
        this._selected = selected;
        this._asc = asc;
    }

    static fromDefault() {
        return new MonthlyPresenceSorting(
            MonthlyPresenceSorting.WORKER_DNI,
            {
                [MonthlyPresenceSorting.WORKER_DNI]: true,
                [MonthlyPresenceSorting.WORKER_NAME]: true,
                [MonthlyPresenceSorting.WORKER_COMPANY]: true,
            },
        );
    }

    selectedColumn() {
        return this._selected;
    }

    isColumnSelected(column) {
        return this._selected === column;
    }

    selectColumn(column) {
        this._selected = column;
    }

    isColumnOrientationAsc(column) {
        return this._asc[column];
    }

    changeOrientation(column) {
        this._asc[column] = !this._asc[column];
    }

    clone() {
        return new MonthlyPresenceSorting(
            this._selected,
            { ...this._asc },
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/monthly/MonthlyPresenceSorting.js